module.exports = __webpack_public_path__ + "static/media/complexPic18.92fa9e0c.png";